import React from "react";
import { useLocation } from "react-router-dom";
import { MenuHeader, MenuHeaderLink } from "./HeaderMenu.styled";

export const HeaderMenu = () => {
  const location = useLocation();
  let whiteText = location.pathname.includes("/collections/") || location.pathname.includes("/creators/");

  return (
    <MenuHeader>
      <MenuHeaderLink to='/marketplace' whiteText={whiteText}>
        Mаrketplаce
      </MenuHeaderLink>
      <MenuHeaderLink to='/' whiteText={whiteText}>
        Telegrаm Chаnnel
      </MenuHeaderLink>
      <MenuHeaderLink to='/faq' whiteText={whiteText}>
        FАQ
      </MenuHeaderLink>
    </MenuHeader>
  );
};
